import { render, staticRenderFns } from "./CreatedForm.vue?vue&type=template&id=2060c02b&"
import script from "./CreatedForm.vue?vue&type=script&lang=js&"
export * from "./CreatedForm.vue?vue&type=script&lang=js&"
import style0 from "./CreatedForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports